import React from 'react';

const SocialFields = ({
  oldData, 
  setFriends,
  setChildren,
  setParents,
  setWife,
  setAnimal
}) => {

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Друзья
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.friends}
          placeholder='Друзья'
          onChange={e => { setFriends(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Дети (имена, хобби, взаимоотношения)
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.children}
          placeholder='Дети (имена, хобби, взаимоотношения)'
          onChange={e => { setChildren(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Родители (имена, хобби, взаимоотношения)
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.parents}
          placeholder='Родители (имена, хобби, взаимоотношения)'
          onChange={e => { setParents(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Супруга (имя, хобби, взаимоотношения, история предыдущих отношений)
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.wife}
          placeholder='Супруга (имя, хобби, взаимоотношения, история предыдущих отношений)'
          onChange={e => { setWife(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Животные
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.animals}
          placeholder='Животные'
          onChange={e => { setAnimal(e) }}
      />

    </>
  );
};

export default SocialFields;